import React from 'react';

import { FormMoneyInput, FormYesNoToggle, getFieldName, VerticalLayout } from 'widgets';

export const FinancialPicture = ({ prefix }: { prefix?: string }) => {
    return (
        <VerticalLayout $gap={4}>
            <FormYesNoToggle label="High Net Worth" name={getFieldName('highNetWorth', prefix)} />
            <FormMoneyInput label="Net Worth" name={getFieldName('netWorth', prefix)} />
            <FormMoneyInput label="Liquid Net Worth" name={getFieldName('liquidNetWorth', prefix)} />
            <FormMoneyInput label="Total Assets" name={getFieldName('totalAssets', prefix)} />
            <FormMoneyInput label="Annual Income" name={getFieldName('annualNetIncome', prefix)} />
        </VerticalLayout>
    );
};
